const webmapId = "c04c09f9dccd4040875e660910eb484f";

export { webmapId };
